var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#FCFAFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 23.1667C7.6 22.8507 7.4862 22.5773 7.25859 22.3464C7.03099 22.1155 6.76146 22 6.45 22H4.15C3.83854 22 3.56901 22.1155 3.34141 22.3464C3.1138 22.5773 3 22.8507 3 23.1667V27.8333C3 28.1493 3.1138 28.4227 3.34141 28.6536C3.56901 28.8846 3.83854 29 4.15 29H6.45C6.76146 29 7.03099 28.8846 7.25859 28.6536C7.4862 28.4227 7.6 28.1493 7.6 27.8333V23.1667Z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 13.8333C16.8 13.5174 16.6862 13.2439 16.4586 13.013C16.231 12.7821 15.9615 12.6667 15.65 12.6667H13.35C13.0385 12.6667 12.769 12.7821 12.5414 13.013C12.3138 13.2439 12.2 13.5174 12.2 13.8333V27.8333C12.2 28.1493 12.3138 28.4227 12.5414 28.6536C12.769 28.8846 13.0385 29 13.35 29H15.65C15.9615 29 16.231 28.8846 16.4586 28.6536C16.6862 28.4227 16.8 28.1493 16.8 27.8333V13.8333Z",
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2.16667C26 1.85069 25.8862 1.57726 25.6586 1.34635C25.431 1.11545 25.1615 1 24.85 1H22.55C22.2385 1 21.969 1.11545 21.7414 1.34635C21.5138 1.57726 21.4 1.85069 21.4 2.16667V27.8333C21.4 28.1493 21.5138 28.4227 21.7414 28.6536C21.969 28.8846 22.2385 29 22.55 29H24.85C25.1615 29 25.431 28.8846 25.6586 28.6536C25.8862 28.4227 26 28.1493 26 27.8333V2.16667Z",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon);
export default __webpack_public_path__ + "static/media/statistics-icon.6b719662d7d53f2f9b0664beab56ca14.svg";
export { ForwardRef as ReactComponent };